<template>
  <!-- 修改密码 -->
  <div class="edit-pass">
    <homeHead :hidden="hiddenHead"></homeHead>
    <section class="edit-content">
      <section class="title-content">
        <div id="titleDiv" class="phone-lable">
          <p v-if="title" v-html="title" style="color: #4086F6;"></p>
          <p v-else>请设置新的密码</p>
        </div>
      </section>

      <section class="home-content">
        <!--  @keyup.enter.native="handleSubmit" -->
        <el-form key="b" class="user-layout-login" ref="form" :model="modelPass" :rules="validatorRules">
          <input type="text" autocomplete="off" style="position: fixed;bottom: -9999px;">
          <input type="password" autocomplete="off" style="position: fixed;bottom: -9999px;" />

          <el-form-item required prop="oldPass" class="item-first">
            <el-input name="randomnames" style="position: fixed;bottom: -9999px;" type="text"></el-input>
            <el-input name="randomname" autocomplete="off" type="text" v-model="modelPass.oldPass" minlength="8" maxlength="16" size="large" placeholder="请输入原密码">
            </el-input>
          </el-form-item>
          <el-form-item required prop="newPass" class="item-first">
            <el-input style="position: fixed;bottom: -9999px;" :type="passFlag ? 'password' : 'text'"></el-input>

            <el-input autocomplete="off" v-model="modelPass.newPass" maxlength="16" :type="passFlag ? 'password' : 'text'" size="large" placeholder="请输入密码">
              <template slot="append">
                <div @click="passFlag = !passFlag" class="pass-icon">
                  <img v-if="passFlag" src="../../../../assets/pcHidden.png" alt="" />
                  <img v-if="!passFlag" src="../../../../assets/pcLook.png" alt="" />
                </div>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item required prop="affirmPass" class="item-first">
            <el-input style="position: fixed;bottom: -9999px;" :type="passFlag ? 'password' : 'text'"></el-input>
            <el-input autocomplete="off" v-model="modelPass.affirmPass" maxlength="16" :type="affirmPassFlag ? 'password' : 'text'" size="large" placeholder="请再次输入密码">
              <template slot="append">
                <div @click="affirmPassFlag = !affirmPassFlag" class="pass-icon">
                  <img v-if="affirmPassFlag" src="../../../../assets/pcHidden.png" alt="" />
                  <img v-if="!affirmPassFlag" src="../../../../assets/pcLook.png" alt="" />
                </div>
              </template>
            </el-input>
          </el-form-item>

          <el-form-item class="form-bottom">
            <el-button size="large" type="primary" class="login-button" :disabled="submitBtn" @click.stop.prevent="handleSubmit">确定
            </el-button>
          </el-form-item>
        </el-form>
      </section>
    </section>
  </div>
</template>
<script>
import homeHead from '../../component/homeHead.vue'
import { changeAccountPwd } from '../../../../api/api.p'
import { dateFormat, validatePhone } from '../../../../../src/libs/util'
export default {
  props: {
    title: '',
  },
  data () {
    var validatePassFirst = (rule, value, callback) => {
      if (value == '') {
        callback(new Error('请输入密码！'))
      } else {
        if (value.length >= 8) {
          callback()
        } else {
          callback(new Error('密码格式不正确！'))
        }
      }
    }
    var validatePass = (rule, value, callback) => {
      if (value == '') {
        callback(new Error('请确认密码！'))
      } else {
        if (value == this.modelPass.newPass) {
          callback()
        } else {
          callback(new Error('请输入相同密码！'))
        }
      }
    }
    return {
      oldPhone: '12323343434',
      hiddenHead: false,
      modelPass: {
        oldPass: '',
        newPass: '',
        affirmPass: '',
      },
      validatorRules: {
        oldPass: [{ required: true, message: '请输入原密码!' }],
        newPass: [{ required: true, validator: validatePassFirst }],
        affirmPass: [{ required: true, validator: validatePass }],
      },
      passwordFlag: 'password',
      smsBtnTxt: '',
      canClickCode: true,
      submitBtn: false,
      passFlag: true, // 密码显示
      affirmPassFlag: true, // 确认密码显示
      autocompleteAttribute: 'on',
    }
  },
  filters: {
    dateFormatFilter (val) {
      let str = ''
      str = val ? dateFormat('yyyy-MM-dd hh:mm:ss', val + '000') : '--'
      return str
    },
  },
  components: {
    homeHead,
  },
  created () {
    this.hiddenHead = this.title != undefined && this.title.length > 0;
    if (this.hiddenHead == true) {
      this.modelPass.oldPass = '';
      this.modelPass.newPass = '';
      this.modelPass.affirmPass = '';
      this.autocompleteAttribute = 'off'; // 禁止自动填充
    }
  },
  mounted () {
    const inputElement = document.querySelector('input[name="randomname"]');
    if (inputElement) {
      inputElement.setAttribute('autocomplete', 'off');
      inputElement.setAttribute('readonly', 'true');
      inputElement.addEventListener('focus', function () {
        this.removeAttribute('readonly');
      });
    }
  },
  methods: {
    handleSubmit () {
      this.submitBtn = true
      this.$refs['form'].validate((valid) => {
        if (valid) {
          let loginParams = {
            changeType: '1', // 密码修改方式:1修改密码；2重置密码，3 首次设置密码
            newPsw: this.modelPass.newPass,
            oldPsw: this.modelPass.oldPass,
            userId: localStorage.getItem('userUnifyInfo') ? JSON.parse(localStorage.getItem('userUnifyInfo')).userId : '',
            // "verificationCode": "string"
          }
          changeAccountPwd(loginParams)
            .then((res) => {
              if (res.meta.code == 0) {
                this.$toast(res.meta.message)
                this.$emit('closeResetDialog', false);
                if (this.hiddenHead != true) {
                  this.$router.push({
                    name: 'login',
                  })
                }
              } else {
                this.$toast(res.meta.message)
                this.submitBtn = false
              }
            })
            .catch((err) => {
              this.submitBtn = true
            })
        } else {
          this.submitBtn = false
        }
      })
    },
  },
}
</script>
  
<style lang="less" scoped>
.edit-pass {
  width: 100%;

  .title-content {
    padding: 50px 30px 25px 30px;
    .phone-lable {
      color: #121924;
      font-weight: bold;
      font-size: 21px;
    }

    .phone-new {
      color: #999999;
      font-weight: 400;
      font-size: 14px;
      padding-top: 15px;
    }
  }
  @media (min-width: 500px) {
    .edit-content {
      width: 350px;
      margin: 0 auto;
    }
    .home-content {
      align-items: center;
    }
    .title-content {
      padding: 50px 30px 25px 16px;
    }
  }

  .home-content {
    padding: 25px 30px;
    display: flex;
    //   justify-content: center;
    //   flex-wrap: wrap;
    flex-direction: column;

    .user-layout-login {
      width: 315px;
      .item-first {
        margin-bottom: 30px;
      }

      label {
        font-size: 14px;
      }

      .form-bottom {
        position: relative;

        .pass-text {
          position: absolute;
          bottom: 40px;
          right: 0;
          color: #4086f6;
          font-size: 12px;
          cursor: pointer;
        }
      }

      button.login-button {
        padding: 0 15px;
        font-size: 16px;
        height: 40px;
        width: 100%;
        margin-top: 70px;
      }
      .pass-icon {
        cursor: pointer;
        img {
          width: 20px;
          height: 20px;
        }
      }
    }

    /deep/.el-input__inner {
      border: none !important;
      background: #f5f5f5;
      font-size: 18px;
    }

    .el-button--primary {
      background: #4086f6;
    }

    .el-button {
      border: none;
    }

    /deep/.el-input-group__append {
      border: none;
      background: #f5f5f5;
      color: #4086f6;
      font-size: 14px;

      .code-text {
        cursor: pointer;
      }

      .code-timer {
        color: #999;
      }
    }
  }
  /deep/.el-input__inner {
    &::placeholder {
      font-size: 16px;
    }
  }
}
</style>
  
  
